import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import {
  Field,
  Fields,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { required , typeInteger, typeIntegerOrDecimal, typeIntegerOrDecimalOr0, typeIntegerOrDecimalMin10} from "../../common/Validations";
import { 
  Container, 
  Checkbox,
  Box, 
  Button,
  IconButton,
  InputLabel,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography, 
  Tooltip,
  Input,
  InputAdornment,
  Icon,
  Toolbar,
  MenuItem
} from "@material-ui/core"
import { Autocomplete } from"@material-ui/lab"

import ColorField from "../../components/ColorField/ColorField"
import IconPicker from "../../components/IconPicker/IconPicker"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import Util, { ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'
import { actionGetCategories } from '../../actions/EventActions'
import { actionGetPlaces } from '../../actions/PlaceActions'
import { actionGetUsersByReg } from "../../actions/UserActions"
import { actionSaveRol, actionGetRolesRedimidores } from "../../actions/RolActions"


let _handleSubmitFail;
class AddEditRoles extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={usersFiltred:[], usersSelected:[], permissions:[], placesSelected:[]}
    this.onClean=this.onClean.bind(this)
    this.onSave=this.onSave.bind(this)
    this.onInputChangeUser=this.onInputChangeUser.bind(this)
    this.onChangeUser=this.onChangeUser.bind(this)
    this.renderPermissions=this.renderPermissions.bind(this)
    // this.renderUsers=this.renderUsers.bind(this)
    this.renderPlaces=this.renderPlaces.bind(this)
    _handleSubmitFail=this.handleSubmitFail.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }else{
      this.props.actionGetCategories(()=>{
        const rol = this.props.history.location.state&&this.props.history.location.state.rol
        let permissions = this.props.categoryList.map((c)=>{
          let p = {id:c.id, label:`Control ${c.id}`, selected:false}
          if(this.props.isEditing){
            const permissionsSelected = rol.rolPermissions.find((rp)=>{
              return rp.id==p.id
            })
            console.log("PERMISSIONS SELECTED", permissionsSelected)
            if(permissionsSelected){
              p = permissionsSelected
            }
          }
          return p
        })
        console.log("PERMISSIONS", permissions)

        this.setState({permissions:permissions})
    }, (e)=>{
      console.log("ACTION GET CATEGORIES ERROR", e)
      if(!(e&&e.status&&e.status==401))
          Util.showNoty(ERROR, "No pudimos listar las categorías")
    })
    this.props.actionGetPlaces(null,
      (e)=>{
        console.log("ACTION GET PLACES ERROR", e)
        if(!(e&&e.status&&e.status==401))
          Util.showNoty(ERROR, "No pudimos listar las ubicaciones")
      })
    }
    
    if(this.props.isEditing){
      const {rol}=this.props.history.location.state
      console.log("ROL EDITING", rol, this.props.rol, this.props.history.location)
      this.props.initialize({rolName:rol.rolName, rolDesc:rol.rolDesc})
      this.setState({usersSelected:rol.rolUsers.slice(),placesSelected:rol.rolPlaces.slice()})
    }
  }
  
  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }

  onClean(){
    // if(this.props.isEditing){
    //   let ticket=this.props.history.location.state
    //   this.props.initialize({id:ticket.id, tktColor:"#000000", tktSellRrppEnable:false, tktVisible:true})
    // }else{
    //   this.props.initialize({tktColor:"#000000", tktSellRrppEnable:false, tktVisible:true})
    // }
  }

  onSave(formValues){
    let rolData = {
      rolName:formValues.rolName,
      rolDesc:formValues.rolDesc,
      rolUsers:this.state.usersSelected.map((u)=>{return {id:u.id, proName:u.proName, proLastName:u.proLastName, proEmail:u.proEmail}}),
      rolPermissions:this.state.permissions.filter(p=>p.selected),
      rolPlaces:this.state.placesSelected
    }
    if(this.props.isEditing){
      const rol = this.props.history.location.state&&this.props.history.location.state.rol
      rolData.id=rol.id
    }
    let valid = true
    let dbRolRedimidor = this.props.rolesRedimidoresList&&this.props.rolesRedimidoresList.find((r)=>{return r.rolName == rolData.rolName})
    if(dbRolRedimidor&&(!rolData.id||rolData.id!=dbRolRedimidor.id)){
      valid=false
      Util.showNoty(ERROR,"Ya existe un rol con el nombre ingresado.")
    }
    if(!rolData.rolUsers||rolData.rolUsers.length==0){
      valid=false
      Util.showNoty(ERROR,"Debe asignar el rol al menos a un usuario.")
    }
    if(!rolData.rolPlaces||rolData.rolPlaces.length==0){
      valid=false
      Util.showNoty(ERROR,"Debe asignar el rol al menos a una ubicación.")
    }
    if(valid){
      console.log("ROL DATA", rolData)
      this.props.actionSaveRol(rolData,()=>{
        this.props.actionGetRolesRedimidores()
        Util.showNoty(SUCCESS,`El rol ${rolData.rolName} se ha guardado correctamente`)
        this.props.history.goBack()
      },
      (e)=>{
        Util.showNoty(ERROR,`No pudimos guardar el rol ${rolData.rolName}`)
      })
    }
    
    // this.props.actionSaveTicketType(formValues
    //   , ()=>{Util.showNoty(SUCCESS, "El ticket se guardó correctamente."); this.props.history.goBack()}
    //   , (e)=>{
    //     console.log("ERROR ON SAVE TICKET", e)
    //     if(!(e&&e.status&&e.status==401))
    //       Util.showNoty(ERROR, "No se pudo guardar el ticket.")
    //   }
    // )
  }

  onInputChangeUser(evt){
    if(!this.state.loadingUsers){
      const { userList } = this.props
      const filter = new RegExp(evt.target.value,"gi")
      if(evt.target.value&&evt.target.value.length==3){
        //BUSCAR EN BACKEND
        this.setState({loadingUsers:true})
        this.props.actionGetUsersByReg(evt.target.value, (response)=>{
          console.log("RESPONSE", response)
          let usersFiltred = response.filter((u)=>{
            console.log("USER",u)
            return u.proName&&u.proName.match(filter)||
                  u.proLastName&&u.proLastName.match(filter)||
                  u.proEmail&&u.proEmail.match(filter)
          })
          this.setState({usersFiltred:usersFiltred, loadingUsers:false})
        },(e)=>{
          this.setState({loadingUsers:false})
          console.log("ACTION GET USERS ERROR", e)
          if(!(e&&e.status&&e.status==401))
            Util.showNoty(ERROR, "No pudimos listar los usuarios")
        })
      }else{
        if(evt.target.value&&evt.target.value.length>3){
          //FILTRAR EN FRONT
          let usersFiltred = userList&&userList.filter((u)=>{
            return u.proName&&u.proName.match(filter)||
                  u.proLastName&&u.proLastName.match(filter)||
                  u.proEmail&&u.proEmail.match(filter)        
            })
          this.setState({usersFiltred:usersFiltred})
        }
      }
    }
  }

  onChangeUser(evt, users){
    console.log("USERS", users)
    this.setState({usersSelected:users})
  }

  onChangePermissions(permission, event){
    const idx = this.state.permissions.indexOf(permission)
    const p = {...this.state.permissions[idx], selected:event.target.checked}
    const permissions = this.state.permissions.slice()
    permissions[idx]=p
    this.setState({permissions:permissions})
  }

  onChangePlace(place, event){
    console.log("PLACE", place)
    if(event.target.checked){
      let placesSelected = this.state.placesSelected.slice()
      placesSelected.push(place)
      this.setState({placesSelected:placesSelected})
    }else{
      let placesSelected = this.state.placesSelected.filter((p)=>p.id!=place.id)
      this.setState({placesSelected:placesSelected})
    }
  }

  renderPermissions(){
    const { permissions } = this.state
    console.log("renderPermissions", permissions)
    return permissions.map((p,i)=>{
      return (<ListItem key={`p${i}`}>
                <Checkbox color="primary" checked={p.selected} onChange={this.onChangePermissions.bind(this,p)}/>
                <ListItemText primary={p.label}/>
              </ListItem>)
    })
  }

  // renderUsers(){
  //   const { usersSelected } = this.state
  //   console.log("USERS SELECTED", usersSelected)
  //   // let userList = []
  //   // let size = 20
  //   // for(let i = 0;i<size;i++){
  //   //   userList.push()
  //   // }
  //   return usersSelected.map((u,i)=>{
  //     return (<ListItem key={`u${i}`}>
  //               <Checkbox/>
  //               <ListItemText primary={`${u.proName} ${u.proLastName}`} secondary={u.proEmail}/>
  //             </ListItem>)
  //   })
  // }

  renderPlaces(){
    const { placeList } = this.props
    console.log("PLACES SELECTED", this.state.placesSelected)
    return placeList&&placeList.map((p,i)=>{
      const isChecked = this.state.placesSelected.find((ps)=>p.id==ps.id)?true:false
      console.log("PLACE", p, isChecked)
      return (<ListItem key={`pl${i}`}>
                <Checkbox color="primary" checked={isChecked} onChange={this.onChangePlace.bind(this,p)}/>
                <ListItemText primary={p.plcName} secondary={p.plcAddress}/>
              </ListItem>)
    })
  }

  render(){
    const { theme, handleSubmit, event, ticketFormValues, categoryList } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <Tooltip title="Atrás">
              <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
                <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
              </IconButton>
            </Tooltip>  
          </Box>
          <Box>
            <Typography variant="h1">Crear rol</Typography>
            <Typography variant="subtitle1">Crea rol</Typography>
          </Box>
        </Box> 
        <Container>        
          <Paper >
            <Box>
              <Typography style={theme.paper.title} variant="h2">Crear rol</Typography>
            </Box>            
            <form style={theme.paper.form}>
              <Grid container spacing={2}>
           
                <Grid container item xs={3}>
                  <Grid item>
                    <Field
                      component={TextField}
                      name="rolName"
                      label="Nombre del rol"
                      fullWidth
                      validate={[required]}
                    />
                  </Grid>
                  <Grid item>
                    <Field
                        component={TextField}
                        multiline
                        rows={5}
                        name="rolDesc"
                        label="Descripción del rol"
                        fullWidth
                    />
                  </Grid>
                  
                </Grid>
                {/* <Grid item xs={3}>
                  <InputLabel shrink fullWidth>Usuarios</InputLabel>
                  <List style={{height:200, overflow:"auto"}}>
                    {this.renderUsers()}
                  </List>
                </Grid> */}
                <Grid item xs={3}>
                    {/* <InputLabel shrink fullWidth>Agregar usuarios</InputLabel> */}
                    <Autocomplete  
                      options={this.state.usersFiltred}
                      value={this.state.usersSelected}
                      getOptionLabel={option=>`${option.proName} ${option.proLastName}`}
                      renderInput={params=>{
                        return <TextField {...params} fullWidth label="Agregar usuarios" helperText="Escriba al menos 3 letras para buscar"/>
                      }}
                      renderOption={(u)=><ListItemText primary={`${u.proName} ${u.proLastName}`} secondary={u.proEmail}/>}
                      onChange={this.onChangeUser}
                      onInputChange={this.onInputChangeUser}
                      loading={this.state.loadingUsers}
                      loadingText="Cargando usuarios ..."
                      noOptionsText="Sin usuarios"
                      multiple
                      disableCloseOnSelect
                    />
                  </Grid>
                <Grid item xs={3}>
                  <InputLabel shrink fullWidth>Permisos</InputLabel>
                  <List>
                    {this.renderPermissions()}
                  </List>
                </Grid>
                
                <Grid item xs={3}>
                  <InputLabel shrink fullWidth>Ubicaciones</InputLabel>
                  <List style={{height:200, overflow:"auto"}}> 
                    {this.renderPlaces()}
                  </List>
                </Grid>
              </Grid>
            </form>
          </Paper>
          <Toolbar style={theme.footer.toolbar}>
            {/* <Tooltip title="Limpiar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.onClean}>Limpiar</Button>
            </Tooltip> */}
            <Tooltip title="Cancelar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.props.history.goBack}>Cancelar</Button>
            </Tooltip>
            <Tooltip title="Guardar">
              <Button variant="contained" color="primary" style={theme.footer.button} onClick={handleSubmit(this.onSave)}>Guardar</Button>
            </Tooltip>                  
          </Toolbar>
        </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  console.log("STORE", store)
  return {
    login: store.auth.login,
    categoryList: store.evt.categoryList,
    placeList: store.plc.placeList,
    userList: store.usr.userList,
    rolesRedimidoresList: store.rol.rolesRedimidoresList,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetCategories,
      actionGetPlaces,
      actionGetUsersByReg,
      actionSaveRol,
      actionGetRolesRedimidores
    },
    dispatch
  );
}

export default  reduxForm({
  form: "addEditRoles",
  onSubmitFail: errors => _handleSubmitFail(errors)
})(withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(AddEditRoles)
    )
  )
)


// WEBPACK FOOTER //
// ./src/screens/roles/AddEditRoles.js